import type { ExtendedConstraints, CapabilityConfig } from '../../types';
import { hasOnlyKeysFromSet } from '../../utils';

export const id = 'photo-capture';

export enum Events {}

export enum Actions {
  Start = 'photo-capture:start',
}

export type Config = CapabilityConfig & {
  type: typeof id;
};

export type Constraints = ExtendedConstraints<{
  events: Events;
  actions: Actions;
  config: Config;
  actionPayloadTuple: [Actions.Start];
}>;

const VALID_CONFIG_KEYS = ['type'] as const;
export function isValidConfig(config: CapabilityConfig): config is Config {
  if (!hasOnlyKeysFromSet(config, VALID_CONFIG_KEYS)) {
    return false;
  }

  if (config.type !== id) {
    return false;
  }

  return true;
}
